import pageActions from '../page/actions';

export default (state = {}, action) => {
  switch (action.type) {
    case pageActions.GO_SUCCESS:
      return (action.payload.data.meta && action.payload.data.meta.bundles) || {};
    default:
      return state;
  }
};
